import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16.599 1.994h-4.605c-.374 0-.726.146-.99.41l-8.599 8.599c-.265.264-.41.616-.41.99s.146.726.41.99l4.605 4.605c.265.265.616.41.99.41s.726-.146.99-.41l8.6-8.599c.264-.265.41-.616.41-.99V3.394c0-.772-.628-1.401-1.401-1.401zm-1.038 4.567c-.283.283-.66.439-1.061.439s-.777-.156-1.061-.439C13.156 6.278 13 5.901 13 5.5s.156-.777.439-1.061c.283-.283.66-.439 1.061-.439s.777.156 1.061.439c.283.283.439.66.439 1.061s-.156.777-.439 1.061z',
  ],
  height: 20,
  width: 20,
});
